import { motion } from "framer-motion";

// Reusable inner page hero — light theme.
export const PageHeader = ({ eyebrow, title, subtitle, image }) => (
  <section className="relative pt-32 pb-10 md:pt-36 md:pb-14 overflow-hidden bg-white border-b border-slate-200">
    {image && (
      <div className="absolute inset-0 -z-10">
        <img src={image} alt="" className="w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0.9) 60%, rgba(255,255,255,1) 100%)" }} />
      </div>
    )}
    <div className="absolute inset-0 grid-lines -z-10 opacity-70" />
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      {eyebrow && (
        <motion.span
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="eyebrow"
        >
          {eyebrow}
        </motion.span>
      )}
      <motion.h1
        initial={{ opacity: 0, y: 26 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.1, ease: [0.2, 0.8, 0.2, 1] }}
        className="mt-3 text-3xl sm:text-4xl lg:text-5xl max-w-3xl text-slate-900"
      >
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className="mt-3 text-dim text-sm md:text-base max-w-2xl leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  </section>
);

export default PageHeader;
